import React from 'react';
import { Text } from 'library';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { SectionContainer } from './SectionContainer';
import { useUserContext } from 'UserContext';

export default function LocationSection() {
    const { user } = useUserContext();
    const { form } = useJobFormContext();
    const { address } = form.fieldStates;

    if (!address.value || address.value.length === 0) return null;
    const firstAddress = address.value[0];
    const location = user?.address.find((a) => a.id === firstAddress.id);

    return (
        <SectionContainer>
            <Text variant="h2" bold textStyle={styles.header}>
                Location
            </Text>
            <Text variant="body2">
                {location?.description}, {location?.street}, {location?.city}, {location?.state} {location?.zip_code}
            </Text>
        </SectionContainer>
    );
}

const styles = {
    header: {
        marginBottom: 8,
    },
};
